import { render, staticRenderFns } from "./OsPanel.vue?vue&type=template&id=3d70925b&scoped=true&"
import script from "./OsPanel.vue?vue&type=script&lang=js&"
export * from "./OsPanel.vue?vue&type=script&lang=js&"
import style0 from "./OsPanel.vue?vue&type=style&index=0&id=3d70925b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70925b",
  null
  
)

export default component.exports